import { render } from "./AttachmentItem.vue?vue&type=template&id=13031a65"
import script from "./AttachmentItem.vue?vue&type=script&lang=ts"
export * from "./AttachmentItem.vue?vue&type=script&lang=ts"

import "./AttachmentItem.vue?vue&type=style&index=0&id=13031a65&lang=scss"
script.render = render

export default script